// extracted by mini-css-extract-plugin
module.exports = {"root":"BlockDefault_root__8ZykL","media":"BlockDefault_media__2v9oZ","text":"BlockDefault_text__H_EGc"};